<main id="main-content" class="main-content">
    <div class="red-warning" *ngIf="errorList.length > 0">
        <mat-icon class="red-warn-icon">warning</mat-icon>
        <div class="red-warn-text">
            <span class="red-title">Incomplete section</span>
            <span class="red-text">
                The following fields are missing details. Please complete them before proceeding to the next section:
                <ul>
                    @for (error of errorList; track error) {
                    <li>{{error | titlecase}}</li>
                    }
                </ul>
            </span>
        </div>
    </div>
    <div class="subtitle"><span class="red-normal">*</span>Indicates required field</div>
    <h2 class="form-header">3. Additional Information</h2>

    <mat-card [formGroup]="form">
        <div class="title">3a. Treatment Success, Failures and Recommendations</div>
        <div class="bar">&nbsp;</div>
        <div class="text-div">
            <b><span class="red-normal">*</span>Provide additional information on treatment success and/or failures.</b>
            <br>
        </div>
        <span class="gray-text tip-text"><b>Tip:</b> Use Ctrl+Shift+V to paste as plain text.</span>
        <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor formControlName="success_failure" [editor]="editor1" required placeholder="Enter Description"
                (ngModelChange)="onChangeEditor($event, 'success_failure')"></ngx-editor>
        </div>
        <div class="text-div">
            <b><span class="red-normal">*</span>Provide any recommendations for future treatments. </b>
            <br>
        </div>
        <span class="gray-text tip-text"><b>Tip:</b> Use Ctrl+Shift+V to paste as plain text.</span>
        <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="editor2" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor formControlName="recommendations" [editor]="editor2" required placeholder="Enter Description"
                (ngModelChange)="onChangeEditor($event, 'recommendations')"></ngx-editor>
        </div>
        <div class="text-div">
            <b><span class="red-normal">*</span>Provide additional information on plans for project completion.</b>
            <br>
        </div>
        <span class="gray-text tip-text"><b>Tip:</b> Use Ctrl+Shift+V to paste as plain text.</span>
        <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="editor3" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor formControlName="plans" [editor]="editor3" required placeholder="Enter Description"
                (ngModelChange)="onChangeEditor($event, 'plans')"></ngx-editor>
        </div>


    </mat-card>
    <mat-card>
        <div class="title">3b. Additional Reports</div>
        <div class="bar">&nbsp;</div>
        <div class="whole-line">

            <div class="text-div">
                <b>Please provide any links to monitoring or show-and-shine reports.</b>
            </div>
            <button class="usa-button usa-button--secondary medium-length add-button"
                (click)="createAdditionalReport()">
                <mat-icon>add</mat-icon>Add Report Link
            </button>
        </div>
        @for(additionalReport of additional_reports; track additionalReport; let j = $index) {
        <div class="whole-line" [formGroup]="additionalReport.form">
            <mat-form-field appearance="outline" class="short-field">
                <mat-label>Report Name</mat-label>
                <input matInput formControlName="name" aria-label="Name">
                <mat-error>Required Field</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="long-field">
                <mat-label>Link</mat-label>
                <input matInput formControlName="link" aria-label="link"
                    placeholder="Enter url eg. https://www.fs.usda.gov/">
                <mat-error>Please enter a valid URL.</mat-error>
            </mat-form-field>
            <button class="delete-div" (click)="deleteAdditionalReport(additionalReport.additional_report_id)"
                matTooltip='Remove' matTooltipClass="tooltipClass" *ngIf="j > 0">
                <fa-icon [icon]="faCircleXmark" class="fa-regular fa-circle-mark delete-row-icon"
                    aria-label="close"></fa-icon>
            </button>
            <div *ngIf="j==0" style="width: 40px;"></div>
        </div>
        }
    </mat-card>
</main>